import React, { useEffect, useState } from "react";

interface StickyActionsProps {
  src?: string | null;
}

const StickyActions: React.FC<StickyActionsProps> = ({ src }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const hero = document.querySelector('[data-section="hero"]');
      if (!hero) return;
      const rect = hero.getBoundingClientRect();
      setShow(rect.bottom < 0);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"} sm:hidden pointer-events-none`}
      aria-hidden={!show}
    >
      <div className="flex gap-2 justify-center bg-gradient-to-t from-[#18182f] to-transparent py-3 pointer-events-auto">
        <a href="/waiver" className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold shadow" data-cta="waiver">Start Waiver</a>
        <a href="/waiver" className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold shadow" data-cta="coins">Load Coins</a>
      </div>
    </div>
  );
};

export default StickyActions;
